import { Skeleton } from '@material-ui/lab';
import { Move, TrashErrorIconTwoTone } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
import { HandleRemoveImagesProps } from 'shared/interfaces/IModalForm';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { UploadImageContainer, CustomActioButtons } from './UploadImage.styles';
import { useMemo } from 'react';
import useImageLoader from 'shared/hooks/useImageLoader';

type UploadedImageProps = {
  firstLoad: boolean;
  image_url: string;
  index: number;
  handleRemoveImages: HandleRemoveImagesProps;
  id: string | number;
};

const UploadedImage = ({ image_url, index, handleRemoveImages, id, firstLoad }: UploadedImageProps) => {
  const { imageLoaded } = useImageLoader(image_url);
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: id?.toString(),
    animateLayoutChanges: () => false,
    transition: {
      duration: 500,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
  };

  const imageUrl = useMemo(() => {
    if (!imageLoaded && firstLoad) return '';
    return image_url;
  }, [imageLoaded, image_url, firstLoad]);

  return (
    <UploadImageContainer style={style} ref={setNodeRef}>
      <CustomActioButtons
        onClick={() => {
          handleRemoveImages(index);
        }}
      >
        <TrashErrorIconTwoTone htmlColor="white" fontSize="inherit" />
      </CustomActioButtons>
      <CustomActioButtons
        {...attributes}
        {...listeners}
        style={{
          cursor: isDragging ? 'grabbing' : 'grab',
        }}
        isDrag={true}
      >
        <Move viewBox="0 0 16 16" style={{ fontSize: 12 }} htmlColor={COLORS.WHITE} />
      </CustomActioButtons>

      {imageLoaded || !firstLoad ? (
        <img src={imageUrl} style={{ width: '100%', height: 'auto', borderRadius: '8px', pointerEvents: 'none' }} />
      ) : (
        <Skeleton variant="rect" style={{ aspectRatio: '16/9', width: '100%', height: 'auto', borderRadius: '8px' }} />
      )}
    </UploadImageContainer>
  );
};

export default UploadedImage;
